import { DentalLabOrder, DentalLabOrderPayload } from "../interfaces/DentalLabOrder";
import { Get, Patch, Post, Delete } from "./apiHelper";

const dentalLabOrderRoot = "/api/dental-lab-orders";

interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

export const getDentalLabOrders = async ({
  page,
  pageSize,
  from,
  until,
  clientIds = []
}: {
  page: number;
  pageSize: number;
  from?: Date;
  until?: Date;
  clientIds?: Array<number>;
}): Promise<
  ApiResponse<{
    results: DentalLabOrder[];
    total: number;
  } | null>
> => {
  const params = new URLSearchParams();

  if (from) params.append("from", from.toISOString());
  if (until) params.append("until", until.toISOString());
  if (clientIds.length > 0) params.append("clientIds", clientIds.join(","));
  if (page !== undefined) params.append("page", page.toString());
  if (pageSize !== undefined) params.append("pageSize", pageSize.toString());

  const queryString = params.toString();
  const url = `${dentalLabOrderRoot}${queryString ? `?${queryString}` : ""}`;

  const response = await Get(url, true);
  return response.data as ApiResponse<{
    results: DentalLabOrder[];
    total: number;
  } | null>;
};

export const getDentalLabOrder = async (
  id: string | number
): Promise<ApiResponse<DentalLabOrder>> => {
  const response = await Get(`${dentalLabOrderRoot}/${id}`, true);
  return response.data as ApiResponse<DentalLabOrder>;
};

export const postDentalLabOrder = async (
  payload: Partial<DentalLabOrderPayload>
): Promise<ApiResponse<DentalLabOrder>> => {
  const response = await Post(dentalLabOrderRoot, payload, true);
  return response.data as ApiResponse<DentalLabOrder>;
};

export const patchDentalLabOrder = async (
  id: string | number,
  payload: Partial<DentalLabOrderPayload>
): Promise<ApiResponse<DentalLabOrder>> => {
  const response = await Patch(`${dentalLabOrderRoot}/${id}`, payload, true);
  return response.data as ApiResponse<DentalLabOrder>;
};

export const updateDentalLabOrderStatus = async (
  id: string | number,
  payload: Partial<DentalLabOrderPayload>
): Promise<ApiResponse<DentalLabOrder>> => {
  const response = await Patch(`${dentalLabOrderRoot}/${id}/updateStatus`, payload, true);
  return response.data as ApiResponse<DentalLabOrder>;
};

export const deleteDentalLabOrder = async (id: string | number): Promise<ApiResponse<null>> => {
  const response = await Delete(`${dentalLabOrderRoot}/${id}`, true);
  return response.data as ApiResponse<null>;
};
